/*
 * @Author: Dom
 * @Date: 2022-05-18 18:14:55
 * @LastEditTime: 2022-05-31 15:15:49
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\personal\component\phone\locales\zh-TW.ts
 */
export default {
    'page.personal.center.compontent.bindphone.tips' : '輸入綁定手機號',
    'page.personal.center.compontent.codenumber.tips' : '輸入圖形驗證碼',
    'page.personal.center.compontent.msgnumber.tips' : '輸入短信驗證碼',
    'page.personal.center.compontent.password.tips' : '輸入登錄密碼',
    'page.personal.center.compontent.phone.btnconfirm' : '確認綁定',
    'page.personal.center.compontent.phone.btnconfirm.change' : '確認修改',
    'page.personal.center.compontent.phone.required' : '手機號碼不能為空',
    'page.personal.center.compontent.btnctrl' : '取消',
    'page.personal.center.compontent.close' : '關閉',
    'page.personal.center.compontent.btnchangetxt':'換一換',
    'page.personal.center.compontent.verificationtxt':'獲取驗證碼',
    'page.personal.center.compontent.verificationtxtrepeat':'重新獲取驗證碼',
    'page.personal.center.compontent.bindsuccess':'手機號碼綁定成功!',
    'page.personal.center.compontent.countdown.tips':'秒後重新發送',
}
